<template>
	<div class="d-flex justify-content-center" :class="{ 'bg-white': loading }">
		<div v-if="loading" class="p-5 m-5">Loading meal plan...</div>
		<meal-plan-card title="Meals for Today" :meals="meal" v-if="!loading" />
	</div>
</template>

<script setup>
	import MealPlanCard from "@/components/MealPlanCard.vue"
	import { ref, onMounted } from "vue"
	import moment from "moment-timezone"
	import { useTokenStore } from "@/stores/token"
	// import { useRouter } from "vue-router"
	// import { hasTokenIssue, handleTokenIssue } from "@/utils/tokenIssue"
	import { fetchWithAuth } from "@/utils/api-client"
	// import mockData from "@/utils/mockData"

	const meal = ref({})
	const loading = ref(false)

	// const router = useRouter()
	const tokenStore = useTokenStore()

	const fetchTodayData = async () => {
		try {
			loading.value = true
			const tz = Intl.DateTimeFormat().resolvedOptions().timeZone
			const response = await fetchWithAuth("/api/meal-plan", {
				method: "GET",
				headers: {
					"User-Timezone": tz,
					// Authorization: `Bearer ${tokenStore.token}`,
				},
			})
			// if (hasTokenIssue(response)) {
			// 	handleTokenIssue(response)
			// } else {
			const data = await response.json()
			const today = moment().format("MM/DD/YYYY")
			meal.value = data?.entry
				? data.entry[today]
					? data.entry[today]
					: {}
				: {}
			// }
		} catch (error) {
			console.error("Error:", error)
		} finally {
			loading.value = false
		}
	}

	onMounted(fetchTodayData)
</script>

<style scoped></style>
